import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { rgba } from 'polished';
import { COLORS } from 'styleguide';

const ChangesItemValue = styled.div`
  min-height: 26px;
  max-width: 50%;
  padding: 7px;
  border-radius: 2px;
  color: ${props => (props.error ? COLORS.error : COLORS.success)};
  background-color: ${props => (rgba(props.error ? COLORS.error : COLORS.success, 0.12))};
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

ChangesItemValue.propTypes = {
  error: PropTypes.bool,
};

ChangesItemValue.defaultProps = {
  error: false,
};

export default ChangesItemValue;
